export const SLIDESHOWS_GET = 'SLIDESHOWS_GET';
export const SLIDESHOW_ADD = 'SLIDESHOW_ADD';
export const SLIDESHOW_EDIT = 'SLIDESHOW_EDIT';
export const SLIDESHOW_GET = 'SLIDESHOW_GET';
export const SLIDESHOW_UPLOADFILE = 'SLIDESHOW_UPLOADFILE';
export const SLIDESHOW_DELETE = 'SLIDESHOW_DELETE';
